import { useContext } from "react";
import { AppContext } from "../../context/index";
import { Column } from "iuvity-ui-components/dist/column";
import { DataTable } from "iuvity-ui-components/dist/datatable";
import { formatDateToLocale } from '../../helpers/formatDate'

interface LastChangesTableProps {
  title: string;
  data: any;
  columns: any;
};

export const LastChangesTable: React.FC<LastChangesTableProps> = ({
  title,
  data,
  columns
}) => {
  const {
    t,
    appState: { language }
  } = useContext(AppContext);

  return (
    <div className="last-changes-container">
      <div className="title">
        {title}
      </div>
      <div className="table-container">
        <DataTable
          header={false}
          currentPageReportTemplate={t(
            "ConsoleTranslations.rowsPaginatorTemplateLabel"
          )}
          paginatorRight={t('ConsoleTranslations.itemsTextDatatableLabel')}
          emptyMessage={t("TableActions.emptyMessage")}
          rows={10}
          dataKey="id"
          value={data?.map((item: any) => ({
            ...item,
            creationDate: formatDateToLocale(item.creationDate, language)
          }))}
          scrollable
          resizableColumns
          paginator={false}
          className="px-4 pt-0 pb-4"
        >
          {columns.map((col: any) => (
            <Column
              key={col.field}
              field={col.field}
              header={col.header}
              style={{ backgroundColor: "var(--cardBackgroundColorOne) !important", minWidth: "10rem" }}
            />
          ))}
        </DataTable>
      </div>
    </div>
  );
};
